
import { useContext, useEffect, useState } from "react";
import { StateContext } from "../../Middleware/context/StateProvider";
import { useAuth } from "../../Middleware/context/AuthContext";
import { db } from "../../Middleware/Firebase/firebase";
import { addDoc, collection } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { FGetBankTouaki } from "../../Middleware/Firebase/FGetBankTouaki"; // <- importe nomeado se arquivo exporta nomeado
import Spinner from "./Spinner";






function TransferIBAN({custoTotal}) {


const navigate = useNavigate();

  const { user, userProfile } = useAuth();
  const [code, setCode] = useState("");

  // Se o teu StateContext expõe { state, dispatch }, ajusta aqui:
  const basket = useContext(StateContext); // verifica se basket.state existe
  const items = basket?.state ?? [];


 // Banco
  const [bank, setBank] = useState([]);     // <- começa como array
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);

  //-------------------------------


//-------------------------------


//-----------------------------------------------------
  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        setLoading(true);
        const data = await FGetBankTouaki(); // deve retornar array
        if (alive) setBank(Array.isArray(data) ? data : [data]); // normaliza para array
      } catch (e) {
        if (alive) setErr(e.message || "Falha ao buscar dados bancários.");
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, []);


//--------------------------------------------------------------

  const askOrder = async () => {
  
    try {
      // 1) Pré-validações
      if (!user?.uid) {
        alert("Precisas iniciar sessão para enviar o pedido.");
        return;
      }

      if (!Array.isArray(items.basket) || items.basket.length === 0) {
        alert("O carrinho está vazio.");
        return;
      }

      if (!code.trim()) {
        alert("Insere o código de referência do pagamento.");
        return;
      }

      // 2) Monta o payload
      const orderData = {
        requester: userProfile?.nome ?? user?.email ?? "Anónimo",
        requesterId: user.uid,
        whatsapp: userProfile?.telefone ?? "",
        items,               // <- carrinho
        payCode: code.trim(),// <- código de pagamento
        createdAt: new Date(), // ou serverTimestamp() se quiser
        total:custoTotal // total do produto para calcular total de facturas
        
      };
     

      // 3) Envia para o Firestore
      await addDoc(collection(db, "orders"), orderData);

      // 4) Feedback e navegação
      alert("O seu pedido foi enviado com sucesso!");
      // Opcional: limpar estado local, ex. setCode("");
      // Opcional: limpar carrinho via dispatch
      navigate("/");
    } catch (err) {
      console.error("Erro ao enviar pedido:", err);
      alert("Ocorreu um erro ao enviar o pedido. Tente novamente.");
    }
  };

 const referencia = bank?.[0]?.PagamentoIBAN ?? "—";


  return (
<> 
{loading && <Spinner/>}

    <div className="payment-form fade">
      <h3>Transferência Bancária</h3>

      <p><b>IBAN:</b>{referencia}</p>
       <p><b>Enviar o recibo para: </b>touakigestao@gmail.com</p>
      <input 
        name="numero"
        value={code}
        onChange={(e) => setCode(e.target.value)}
        placeholder="Código do comprovativo"
       />

      <button onClick={askOrder} className="pay-btn">Confirmar Transferência</button>
    </div>

 </>
  );
}

export default TransferIBAN;
